/*
  Carousel slides that are scrolled out of view get aria-hidden="true" from slideshow.js,
  but their links and buttons stayed in the keyboard/agent focus order. That fails the
  "ARIA hidden element must not be focusable" check (Lighthouse accessibility + agentic browsing).

  While a slide is aria-hidden, its focusable elements get tabindex="-1" (the original value is
  remembered and put back when the slide becomes visible). Clicking or tapping still works:
  tabindex only affects keyboard focus, so a half-visible "peeking" card stays tappable.
*/
(function () {
  var FOCUSABLE = 'a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex]';
  var STORE = 'data-hh-tabindex';

  function update(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    var items = slide.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (hidden) {
        if (!el.hasAttribute(STORE)) {
          el.setAttribute(STORE, el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute(STORE)) {
        var original = el.getAttribute(STORE);
        if (original === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', original);
        el.removeAttribute(STORE);
      }
    }
  }

  function updateAll(root) {
    var slides = (root || document).querySelectorAll('slideshow-slide[aria-hidden]');
    for (var i = 0; i < slides.length; i++) update(slides[i]);
  }

  updateAll();

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && m.target.localName === 'slideshow-slide') {
        update(m.target);
      } else if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.localName === 'slideshow-slide' && node.hasAttribute('aria-hidden')) update(node);
          else if (node.querySelector) updateAll(node);
        }
      }
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true, childList: true });
})();